<template>
  <b-spinner v-if="spinner_i" variant="success"></b-spinner>
  <i
    v-else
    style="cursor: pointer"
    class="btn-edit fas fa-money-check"
    title="Mover para aguardando nota fiscal"
    @click="proximoStatus()"
  >
  </i>
</template>
<script>
import barramento from "../../../../barramento";
import swal from "sweetalert2";
export default {
  name: "SeparadosButtonSolicitarNFe",
  props: ["pedido_id"],
  data() {
    return {
      spinner_i: false,
    };
  },
  methods: {
    proximoStatus() {
      swal({
        title: this.$t("Você tem certeza?"),
        type: "warning",
        text: this.$t(
          "Ao continuar você irá pular para o status aguardando NF-e, continuar?"
        ),
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showCancelButton: true,
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
      }).then((ok) => {
        if (ok.value === true) {
          this.spinner_i = true;
          barramento.$emit(`expedition_splice_separado`, {
            status: "warning",
            ids: [this.pedido_id],
          });
          this.$http
            .post("/api/orders/updatestatus", [
              {
                id: this.pedido_id,
                status: null,
                sub_status: "waiting_invoice",
              },
            ])
            .then((response) => {
              this.spinner_i = false;
              barramento.$emit(`expedition_splice_separado`, {
                status: "success",
                ids: [this.pedido_id],
              });
              setTimeout(() => {
                barramento.$emit(`expedition_splice_separado`, {
                  status: "splice",
                  ids: [this.pedido_id],
                });
              }, 2000);
            })
            .catch((error) => {
              this.spinner_i = false;
              let errors = '';
              for (const [key, value] of Object.entries(error.response.data)) {
                  errors += `<li><strong>${key}:</strong> ${value}</li>`;
              }
              swal({
                title: "Ops!",
                type: "warning",
                html: `<ul>${errors}</ul>`,
              });
            });
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Expeditions_v2/Aggregates/Nfe/SeparadosButtonSolicitarNFe.vue